import React, { useState } from "react";
import { FaUniversity, FaCreditCard, FaLock, FaUser, FaPhone, FaQrcode } from "react-icons/fa";

const PaymentInfo = ({ data, setData, onSkip }) => {
  const [method, setMethod] = useState(data.method || "");
  const [skipPayment, setSkipPayment] = useState(data.skipPayment || false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleMethodChange = (e) => {
    const value = e.target.value;
    setMethod(value);
    setData({ ...data, method: value });
  };

  const handleSkip = () => {
    setSkipPayment(true);
    setData({ ...data, skipPayment: true, method: "" });
    if (onSkip) {
      onSkip();
    }
  };

  return (
    <div className="p-4 sm:p-6 bg-white rounded-lg shadow-sm">
      <h3 className="text-xl font-semibold text-gray-800 mb-6">Payment Information</h3>

      {!skipPayment && (
        <>
          {/* Payment Method Selector */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Select Payment Method
            </label>
            <div className="flex flex-wrap lg:gap-4">
              <label className="flex items-center space-x-2 cursor-pointer p-3 rounded-lg transition-colors">
                <input
                  type="radio"
                  name="method"
                  value="bank"
                  checked={method === "bank"}
                  onChange={handleMethodChange}
                  className="form-radio text-orange-500 focus:ring-orange-500"
                />
                <span className="text-sm sm:text-base">Bank Transfer</span>
              </label>
              <label className="flex items-center space-x-2 cursor-pointer p-3 rounded-lg transition-colors">
                <input
                  type="radio"
                  name="method"
                  value="upi"
                  checked={method === "upi"}
                  onChange={handleMethodChange}
                  className="form-radio text-orange-500 focus:ring-orange-500"
                />
                <span className="text-sm sm:text-base">UPI Transfer</span>
              </label>
            </div>
          </div>

          {/* Conditional Form Fields */}
          {method === "bank" ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div className="col-span-1 md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <div className="flex items-center space-x-2">
                    <FaUniversity className="text-gray-400" />
                    <span>Bank Account Number</span>
                  </div>
                </label>
                <input
                  type="text"
                  name="accountNumber"
                  value={data.accountNumber || ""}
                  onChange={handleChange}
                  className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors text-sm sm:text-base"
                  placeholder="Enter account number"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <div className="flex items-center space-x-2">
                    <FaCreditCard className="text-gray-400" />
                    <span>Bank Name</span>
                  </div>
                </label>
                <input
                  type="text"
                  name="bankName"
                  value={data.bankName || ""}
                  onChange={handleChange}
                  className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors text-sm sm:text-base"
                  placeholder="Enter bank name"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <div className="flex items-center space-x-2">
                    <FaLock className="text-gray-400" />
                    <span>IFSC Code</span>
                  </div>
                </label>
                <input
                  type="text"
                  name="ifscCode"
                  value={data.ifscCode || ""}
                  onChange={handleChange}
                  className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors text-sm sm:text-base"
                  placeholder="Enter IFSC code"
                />
              </div>
            </div>
          ) : method === "upi" ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <div className="flex items-center space-x-2">
                    <FaUser className="text-gray-400" />
                    <span>Full Name</span>
                  </div>
                </label>
                <input
                  type="text"
                  name="upiName"
                  value={data.upiName || ""}
                  onChange={handleChange}
                  className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors text-sm sm:text-base"
                  placeholder="Enter name"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <div className="flex items-center space-x-2">
                    <FaPhone className="text-gray-400" />
                    <span>Mobile Number</span>
                  </div>
                </label>
                <input
                  type="text"
                  name="upiPhone"
                  value={data.upiPhone || ""}
                  onChange={handleChange}
                  className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors text-sm sm:text-base"
                  placeholder="Enter mobile number"
                />
              </div>

              <div className="col-span-1 md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <div className="flex items-center space-x-2">
                    <FaQrcode className="text-gray-400" />
                    <span>UPI ID</span>
                  </div>
                </label>
                <input
                  type="text"
                  name="upiId"
                  value={data.upiId || ""}
                  onChange={handleChange}
                  className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors text-sm sm:text-base"
                  placeholder="Enter UPI ID"
                />
              </div>
            </div>
          ) : null}

          {/* Skip Payment Information Button */}
          <div className="mt-6 pt-4 border-t border-gray-200">
            <button
              type="button"
              onClick={handleSkip}
              className="w-full px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500 transition-colors"
            >
              Skip Payment Information
            </button>
            <p className="mt-2 text-xs text-gray-500 text-center">
              You can add payment information later in your profile settings
            </p>
          </div>
        </>
      )}

      {/* Show skipped message */}
      {skipPayment && (
        <div className="text-center py-4">
          <p className="text-gray-600">Payment information skipped</p>
          <button
            type="button"
            onClick={() => setSkipPayment(false)}
            className="mt-2 text-sm text-orange-600 hover:text-orange-700 underline"
          >
            Add payment information
          </button>
        </div>
      )}
    </div>
  );
};

export default PaymentInfo;